import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs/operators';
import { SemanticDataResponse } from 'app/dashboard/models/WidgetDashboard.model.component';
import { Observable } from 'rxjs';
import { SemanticTrendsData } from './models/SemanticTrendsData.model';

@Injectable({
  providedIn: 'root',
})
export class SemanticService {
  constructor(private http: HttpClient) {}

  getSemanticIndex(
    dates: { startDate: string; endDate: string },
    customerIds: string,
  ): Observable<SemanticDataResponse> {
    const url = `${environment.customerPath}/customers/semantic/index`;
    const params: HttpParams = new HttpParams()
      .set('start_date', dates.startDate)
      .set('end_date', dates.endDate)
      .set('customers_ids', customerIds);
    return this.http.get<SemanticDataResponse>(url, { params: params }).pipe(map((response) => response));
  }

  getSentimentIndex(
    dates: { startDate: string; endDate: string },
    customerIds: string,
  ): Observable<SemanticDataResponse> {
    const url = `${environment.sentimentPath}corporative/index`;
    const params: HttpParams = new HttpParams()
      .set('start_date', dates.startDate)
      .set('end_date', dates.endDate)
      .set('customers_ids', customerIds);
    return this.http
      .get<SemanticDataResponse>(url, { params: params })
      .pipe(map((response) => response['data'] ?? response));
  }

  getSemanticIndexTrends(
    dates: { startDate: string; endDate: string },
    customersIds: string,
    segmentedBy = 'days',
  ): Observable<SemanticTrendsData[]> {
    const url = `${environment.customerPath}customers/semantic/index/trends/average`;
    const params: HttpParams = new HttpParams()
      .set('start_date', dates.startDate)
      .set('end_date', dates.endDate)
      .set('customers_ids', customersIds)
      .set('segmented_by', segmentedBy);
    return this.http.get<SemanticTrendsData[]>(url, { params: params }).pipe(map((response) => response));
  }

  getSentimentIndexTrends(
    dates: { startDate: string; endDate: string },
    customersIds: string,
    segmentedBy = 'months',
  ): Observable<SemanticTrendsData[]> {
    const url = `${environment.sentimentPath}corporative/index/trends/average`;
    const params: HttpParams = new HttpParams()
      .set('start_date', dates.startDate)
      .set('end_date', dates.endDate)
      .set('customers_ids', customersIds)
      .set('segmented_by', segmentedBy);
    return this.http
      .get<SemanticTrendsData[]>(url, { params: params })
      .pipe(map((response) => response['data'] ?? response));
  }
}
